export class ProjectSettings {
  private static readonly NODE_ENV = process.env.REACT_APP_ENV as string;

  static node_env() {
    return this.NODE_ENV;
  }
}
